import { ReviewJsEnv } from './review_js_env';

/** ReviewJsEnvを操作する人 */
export class Review {
  constructor(private model: ReviewJsEnv) {
    this.model = { ...model };
  }

  updateModel(newModel: ReviewJsEnv) {
    this.model = { ...newModel };
  }

  getModel(): ReviewJsEnv {
    return {
      ...this.model
    };
  }
}
